export enum QuizSettings {
  SCHEME = 'quizSetting:scheme',
  BUTTONS_REVERSED = 'quizSetting:quizButtonReversed',
  FLASHCARDS_FLAG_VISIBLE = 'quizSetting:flagVisible',
  FLASHCARDS_NO_REPEAT = 'quizSetting:noRepeat',
}

export enum QuizType {
  MultipleChoice = 1,
  TrueFalse,
  MultipleCheckbox,
  LabelMatching,
  Flashcard,
  TableFlashcard,
  FillInTheBlank,
  FillInTheBlankRN,
  HotSpot,
  OrderedResponse,
  EnhancedHotSpot,
  Cloze,
  SentenceDragAndDrop,
  OrderedDragAndDrop,
  Matrix,
  Graphic,
  Exhibit,
  ExtendedMultipleCheckbox,
  ExtendedDragAndDrop,
}

export type QuizTypeKeys = keyof typeof QuizType;

export type QuizTypeValues = (typeof QuizType)[QuizTypeKeys];

export type QuesLocalization = Record<string, string>;

export type QuestionsTagSet = Record<string, QuestionsTagData>;
export type MergeTags = Record<string, number[]>;

export interface QuestionsTagData {
  tagID: number;
  tag: string;
  name: string;
  type?: string;
  url?: string;
  overrideName?: string;
  localizationKey?: string;
  accessKey?: string;
  mergeWith?: string[];
}

export interface QuizzesForLocalization {
  title?: string;
  icon: string;
  url?: string;
  tag?: string;
}

export interface QuizzesForLocalizationPayload {
  localization: QuesLocalization;
  tags: QuestionsTagData[];
}
